module.exports = __webpack_public_path__ + "img/baipei8.f6e15939.jpg";